// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Icon_wrapper__14jaH","shadow":"Icon_shadow__3vZ_h","emblem":"Icon_emblem__3loc7"};